export default __webpack_public_path__ + "static/media/Savior's Shield Eternal.6c0c32c7.jpg";